<template>
    <div>
        <div style="display: flex; gap: 10px; margin-bottom: 10px;">
            <div style="width: 250px;">
                <div>{{ $t('AppAlertsCoaAlertsConfigForm.Fabricante') }}</div>
                <Dropdown v-model="form['manufacturer_id']" :options="optionsManufacturers" :filter="true" :dataKey="'id'"
                    style="width: 100%; height: 40px; max-width: 276px;" optionLabel="name" optionValue="id"
                    :class="{'p-invalid': $v.form.manufacturer_id.$error && $v.form.manufacturer_id.$dirty}" />
            </div>
            <div style="width: 250px;">
                <div>{{ $t('AppAlertsCoaAlertsConfigForm.Modelo') }}</div>
                <Dropdown v-model="form['vehicles_manufacturer_models_id']" :options="optionsVehicles" :filter="true"
                    style="width: 100%; height: 40px; max-width: 276px;" optionLabel="name" optionValue="id"
                    @change="getMachineAlerts($event.value)" :disabled="!this.form.manufacturer_id" :dataKey="'id'"
                    :class="{'p-invalid': $v.form.vehicles_manufacturer_models_id.$error && $v.form.vehicles_manufacturer_models_id.$dirty}" />
            </div>
        </div>

        <TabView :activeIndex.sync="active" id="tableDiv">
            <TabPanel v-for="tab in dictionaries" :key="tab.id" :header="tab.label">
                <DataTable :value="gridData" :paginator="true" :rows="6" :loading="loading" :key="dataTableKey"
                        :sortOrder="1" :lazy="true" responsiveLayout="scroll" @page="onPage($event)"
                        :totalRecords="totalRecords" class="p-datatable-striped" :first="page">
                    <template #header>
                        <div>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="filterValue" :placeholder="$t('AppAlertsCoaAlertsConfigForm.Filtrar')" @keyup.enter="onEnterFilter"/>
                            </span>
                        </div>
                    </template>
                    <Column field="code_alert" :header="$t('AppAlertsCoaAlertsConfigForm.Código do Alerta')" headerClass="headerClass" bodyClass="bodyClass"
                        :styles="{'max-width': '3rem'}" />
                    <Column field="description" :header="$t('AppAlertsCoaAlertsConfigForm.Descrição do Fabricante')" headerClass="headerClass" bodyClass="bodyClass"
                            :styles="{'max-width': '3rem'}">
                        <template #body="slotProps">
                            <div v-if="slotProps.data.description != null && slotProps.data.description.length > 30" v-tooltip.top="`${slotProps.data.description}`">
                                {{ slotProps.data.description.slice(0, 30) + ' ...' }}
                            </div>
                            <div v-else>
                                {{ slotProps.data.description }}
                            </div>
                        </template>
                    </Column>
                    <Column header="FMI" headerClass="headerClass" bodyClass="bodyClass" :styles="{'max-width': '3rem'}">
                        <template #body="slotProps">
                            <div v-if="slotProps.data.has_fmi">
                                <Dropdown v-model="slotProps.data.fmi" :options="fmiOptions" optionLabel="name" optionValue="code" appendTo="tableDiv"
                                    @change="getStatusByFMI(slotProps.data)" style="width: 150px;"/>
                            </div>
                        </template>
                    </Column>
                    <Column field="status" header="Status" headerClass="headerClass" bodyClass="bodyClass" :styles="{'max-width': '3rem'}">
                        <template #body="slotProps">
                            <span :class="'badge statusAlert-' + slotProps.data.status">
                                {{ getStatus(slotProps.data.status) }}
                            </span>
                        </template>
                    </Column>
                    <Column headerClass="headerClass" bodyClass="bodyClass" :styles="{'max-width': '1rem'}">
                        <template #body="slotProps">
                            <div v-if="slotProps.data.status">
                                <Button @click="addAlert(slotProps.data)" icon="pi pi-pencil" class="p-button-rounded p-button-success actions" />
                            </div>
                            <div v-else>
                                <Button @click="addAlert(slotProps.data)" icon="pi pi-plus" class="p-button-rounded actions" />
                            </div>
                        </template>
                    </Column>
                </DataTable>
            </TabPanel>
        </TabView>
    </div>
</template>

<script>
import VehiclesManufacturersService from '../../../../services/VehiclesManufacturersService';
import AlertsCoaService from '../../../../services/AlertsCoaService';
import InputText from 'primevue/inputtext/InputText';
import {required} from 'vuelidate/lib/validators';
import Button from 'primevue/button/Button';
import DataTable from 'primevue/datatable';
import {FMI_LIST, STATUSES_ALERT} from '../AppOptionsCoa';
import Dropdown from 'primevue/dropdown';
import TabPanel from 'primevue/tabpanel';
import Tooltip from 'primevue/tooltip';
import TabView from 'primevue/tabview';
import Column from 'primevue/column';
import displayToast from '@/mixins/ToastMixin';

export default {
    mixins: [displayToast],
    props: {
        optionsManufacturers: {
            type: Array,
        },
    },
    data() {
        return {
            active: 0,
            form: {},
            optionsVehicles: [],
            gridData: [],
            dictionaries: [
                { label: this.$t('AppAlertsCoaAlertsConfigForm.Proprietário'), value: "PROPRIETARY" },
                { label: "J1939", value: "J1939" }
            ],
            loading: false,
            orgId: null,
            filterValue: '',
            page: 0,
            fmiOptions: FMI_LIST,
            optionsStatus: STATUSES_ALERT,
            fmi: null,
            totalRecords: 0,
            dataTableKey: 0
        }
    },
    created() {
        this.vehiclesManufacturersService = new VehiclesManufacturersService();
        this.alertsCoaService = new AlertsCoaService();
    },
    methods: {
        getStatusByFMI(){
            this.getMachineAlertsInCOA(this.gridData)
        },
        getStatus(status) {
            let result = this.optionsStatus.find(({code}) => code === status);
            if (result) {
                return result.name;
            }
        },
        cleanForm(orgId){
            this.orgId = orgId
            this.form = {}
        },
        onPage(event) {
            this.page = event.page
            this.getMachineAlerts();
        },
        getMachineAlerts(){
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                this.displayToast(this.$t('AppAlertsCoaAlertsConfigForm.Por favor preencha todos os campos obrigatórios'), 'e')
                return
            }

            if(this.active === 0) {
                this.getMachineAlertsProprietary()
                return
            }
            this.getMachineAlertsJ1939()
        },
        getMachineAlertsProprietary(){
            this.loading = true
            this.alertsCoaService.getMachineAlertsProprietary(this.form.vehicles_manufacturer_models_id, this.page, this.filterValue)
                .then((data) => {
                    this.totalRecords = data.number_of_elements

                    data.content.forEach(element => {
                        element.dictionary = this.active
                        element.code_alert = element.code
                        delete element.code
                        if(element.has_fmi){
                            element.fmi = 0
                            return
                        }
                        element.fmi = null
                    });

                    this.getMachineAlertsInCOA(data.content)
                })
                .catch((error) => {
                    this.gridData = []
                    this.loading = false
                    this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Não foi possível buscar os alertas'), 'e', error)
                });
        },
        getMachineAlertsJ1939(){
            this.loading = true
            this.alertsCoaService.getMachineAlertsJ1939(this.page, this.filterValue)
                .then((data) => {
                    this.totalRecords = data.number_of_elements

                    data.content.forEach(element => {
                        element.dictionary = this.active
                        element.code_alert = element.code
                        delete element.code
                        if(element.has_fmi){
                            element.fmi = 0
                            return
                        }
                        element.fmi = null
                    });

                    this.getMachineAlertsInCOA(data.content)
                })
                .catch((error) => {
                    this.gridData = []
                    this.loading = false
                    this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Não foi possível buscar os alertas'), 'e', error)
                });
        },
        getMachineAlertsInCOA(val){
            this.alertsCoaService.getMachineAlertsInCOA(this.orgId, this.form.vehicles_manufacturer_models_id, val)
                .then((data) => {
                    this.gridData = data
                })
                .catch((error) => {
                    this.gridData = []
                    this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Não foi possível buscar os alertas'), 'e', error)
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        addAlert(data){
            let newData = { ... data}
            newData.model_name = this.optionsVehicles.find(item => item.id === this.form.vehicles_manufacturer_models_id).name,
            newData.manufacturer_id = this.form.manufacturer_id,
            newData.vehicles_manufacturer_models_id = this.form.vehicles_manufacturer_models_id,
            newData.organization_id = this.orgId
            this.$emit('editMachine', newData);
        },
        onEnterFilter() {
            this.dataTableKey++
            this.page = 0
            this.totalRecords = 0
            this.getMachineAlerts()
        },
    },
    watch: {
        'form.manufacturer_id': function (val) {
            this.vehiclesManufacturersService.findAllModelsByManufacturerId(val)
                .then((data) => {
                    if(this.form.vehicles_manufacturer_models_id){
                        this.form.vehicles_manufacturer_models_id = null
                        this.gridData = []
                    }

                    let newData = []
                    data.models.forEach(model => {
                        newData.push({
                            id: model.id,
                            name: model.name
                        })
                    });
                    newData.sort((a, b) => a.name.localeCompare(b.name));
                    this.optionsVehicles = newData;
                })
                .catch((error) => {
                    this.displayToast(this.$t('AppAlertsCoaAlertsConfigForm.Não foi possível buscar os modelos'), 'e', error)
                });
        },
        'form.vehicles_manufacturer_models_id': function() {
            this.dataTableKey++
            this.filterValue = ''
            this.totalRecords = 0
            this.page = 0
            this.getMachineAlerts()
        },
        active: function() {
            this.dataTableKey++
            this.filterValue = ''
            this.page = 0
            this.totalRecords = 0
            this.getMachineAlerts()
        }
    },
    validations: {
        form: {
            vehicles_manufacturer_models_id: {required},
            manufacturer_id: {required}
        }
    },
    components: {
        Button, InputText, Dropdown, DataTable, Column, Tooltip, TabView, TabPanel
    },
    directives: {
        tooltip: Tooltip
    }
}
</script>

<style scoped lang="scss">
@import "src/assets/styles/primevue";
@import "src/components/views/alerts-coa/style";
</style>
